import React, {useState} from 'react';
import {Button, Row, Col, Modal, Card} from 'reactstrap';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import {SweetAlert} from '../Common/SweetAlert';
import {Link} from 'react-router-dom';
import axios from 'axios';
import Dropzone from 'react-dropzone';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';
import {ROLE, RoleNameMap} from '../Role/constants';
import {FormProvider, useForm} from 'react-hook-form';

const ModalPrinterAddFile = (props) => {
  const printer = props.printer;

  const [modal, setModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [noFileSelected, setNoFileSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const form = useForm();
  const {
    handleSubmit, register,
  } = form;

  const authUser = getLoggedInUser();
  const userRole = RoleNameMap.get(authUser.user.role) || ROLE.NONE;

  function removeBodyCss() {
    document.body.classList.add('no_padding');
  }

  function toggleModal() {
    setModal(!modal);
    removeBodyCss();
  }

  function handleValidSubmit(values) {
    if (!selectedFiles.length) {
      setNoFileSelected(true);
      return false;
    }
    setIsLoading(true);
    uploadFile(values);
  }

  function uploadFile(data) {
    const url = process.env.REACT_APP_APIURL + 'printer/' + printer.id +
      '/upload';
    const authToken = authHeader();

    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append('files[]', file);
    });
    formData.append('data', JSON.stringify(data));

    return axios.post(url, formData, {headers: authToken}).then(() => {
      setSuccessMsg(true);
    }).catch(() => {
      setIsLoading(false);
      setErrorMsg(true);
    });
  }

  function handleAcceptedFiles(files) {
    files.map((file) => Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }));

    setSelectedFiles(files);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  return (
    <React.Fragment>
      <button
        className="position-absolute top-15 right-15 p-0 waves-effect
        waves-light btn btn-transparent text-yellow"
        type="button"
        onClick={() => {
          toggleModal();
        }}
        data-toggle="modal"
        data-target=".bs-example-modal-center"
      >
        <i className="font-size-24 bx bxs-cloud-upload"></i>
      </button>
      <Modal
        size="lg"
        isOpen={modal}
        toggle={() => {
          toggleModal();
        }}
        centered={true}
      >
        <div className="modal-body">
          <button
            type="button"
            onClick={() => {
              setModal(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <Row>
            <Col md={1}>
              <div className="avatar-sm">
                <span
                  className="avatar-title rounded-circle bg-primary text-white">
                  <i className="bx bxs-cloud-upload bx-sm"></i>
                </span>
              </div>
            </Col>
            <Col md={11}>
              <div className="mb-2">
                <h5 className="modal-title mt-0">Upload files for
                  printer {printer.printer_serial_no}</h5>
              </div>
              <div className="mb-3">
                <FormProvider {...form}>
                  <form
                    className="form-horizontal mt-4"
                    onSubmit={handleSubmit(handleValidSubmit)}
                  >
                    <Row>
                      <Col md="12">
                        <Dropzone
                          onDrop={(acceptedFiles) => {
                            handleAcceptedFiles(acceptedFiles);
                          }}
                          accept=".pdf,.log"
                          multiple={true}
                        >
                          {({getRootProps, getInputProps}) => (
                            <div className="dropzone">
                              <div
                                className="dz-message needsclick"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="dz-message needsclick">
                                  <div className="mb-3">
                                    <i className="display-4 text-muted bx
                                  bxs-cloud-upload"/>
                                  </div>
                                  <h4>Drop files here or click to upload.</h4>
                                </div>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className="dropzone-previews mt-3"
                          id="file-previews"
                        >
                          {selectedFiles.map((f, i) => {
                            return (
                              <Card
                                className="mt-1 mb-0 shadow-none border
                              dz-processing dz-image-preview dz-success
                              dz-complete"
                                key={i + '-file'}
                              >
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted font-weight-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            );
                          })}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md="12">
                        {(userRole === ROLE.BROTHER_STAFF ||
                          userRole === ROLE.BROTHER_MANAGER) && (
                          <div className="form-group form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="is_restricted"
                              {...register('is_restricted')}
                              onChange={(e) => setValue('is_restricted', e.target.checked ? '1' : '0')}
                            />
                            <label className="form-check-label" htmlFor="is_restricted">
                              Only visible to Brother members
                            </label>
                          </div>
                        )}
                        {isLoading ?
                          <Button
                            className="btn btn-yellow d-flex align-items-center
                          ml-auto"
                            type="submit"
                            disabled={true}
                          >
                            <i className="bx bx-loader bx-spin font-size-16
                          align-middle mr-2"/>
                            Upload files
                          </Button> :
                          <Button
                            className="btn btn-yellow d-flex align-items-center
                          ml-auto"
                            type="submit"
                          >
                            <i className="bx bxs-cloud-upload font-size-24 mr-2"/>
                            Upload files
                          </Button>
                        }
                      </Col>
                    </Row>
                  </form>
                </FormProvider>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
      {successMsg ? <SweetAlert
        title="Good job!"
        success
        showConfirm={true}
        showCancel={false}
        confirmBtnBsStyle="yellow"
        onConfirm={() => {
          window.location.reload();
        }}
      >
        File was uploaded successfully.
      </SweetAlert> : null}
      {errorMsg ? <SweetAlert
        title="Request could not be submitted!"
        warning
        showConfirm={true}
        showCancel={false}
        confirmBtnBsStyle="yellow"
        onConfirm={() => {
          setErrorMsg(false);
        }}
      >
        There was an error while submitting your request. Please try again or
        get in contact with our team.
      </SweetAlert> : null}
      {noFileSelected ? <SweetAlert
        title="No file selected!"
        text="Please select a file to upload."
        warning
        showConfirm={true}
        showCancel={false}
        confirmBtnBsStyle="yellow"
        onConfirm={() => {
          setNoFileSelected(false);
        }}
      /> : null}
    </React.Fragment>
  );
};

export default ModalPrinterAddFile;
